import React from 'react';
import '../styles/designSystem.css';

/* Filtre en PASTILLES — format standard des filtres à valeurs nommées
   (décision 2026-08-27). Chaque valeur est une pastille autonome ; la retenue
   se remplit en navy et porte une coche. Les pastilles passent à la ligne, ce
   qu'un groupe segmenté ne sait pas faire : c'est ce qui les rend lisibles
   quand les valeurs sont nombreuses ou de longueur inégale (les segments d'une
   offre, par exemple). Référence d'origine : People › Chiffres clés
   (« Afficher : Charges de personnel | Frais & débours … »).

   `multiple` (défaut) : plusieurs pastilles retenues, `value` = Set, aucune
   retenue = aucun filtre, donc tout s'affiche. Sinon choix exclusif, `value` =
   la valeur.

     <PillFilter label="Segment" value={sel} onChange={setSel}
                 options={segments.map(s => ({ value: s, label: s }))} />

   Une bascule à deux ou trois choix courts (Tableau | Frise) reste du ressort
   de <SegmentedToggle> : elle dit un MODE, pas une sélection de valeurs. */
export default function PillFilter({
  label = null,
  value,
  onChange,
  options = [],
  multiple = true,
  className = '',
  ariaLabel = null,
}) {
  const held = multiple ? (value instanceof Set ? value : new Set(value || [])) : null;
  const isOn = (opt) => (multiple ? held.has(opt.value) : opt.value === value);
  const press = (opt) => {
    if (!multiple) { onChange(opt.value); return; }
    const next = new Set(held);
    if (next.has(opt.value)) next.delete(opt.value); else next.add(opt.value);
    onChange(next);
  };
  return (
    <div className={`lk-pills${className ? ` ${className}` : ''}`}
         role="group" aria-label={ariaLabel || label || undefined}>
      {label && <span className="lk-pills__lbl">{label}</span>}
      {options.map(opt => {
        const on = isOn(opt);
        return (
          <button
            key={String(opt.value)}
            type="button"
            className={`lk-pill${on ? ' is-on' : ''}`}
            aria-pressed={on}
            title={opt.title || undefined}
            onClick={() => press(opt)}
          >
            {on && <span className="lk-pill__mark" aria-hidden>✓</span>}
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
